import { render } from "./SideSportBar.vue?vue&type=template&id=542e2804&scoped=true"
import script from "./SideSportBar.vue?vue&type=script&lang=js"
export * from "./SideSportBar.vue?vue&type=script&lang=js"

import "./SideSportBar.vue?vue&type=style&index=0&id=542e2804&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-542e2804"]])

export default __exports__